import PageHeader from "@/components/PageHeader";
import Therapies from "@/pages/admin/Therapies";

export default function TherapiesPage() {
  return (
    <div>
      <PageHeader eyebrow="Treatment" title="Therapies" description="Reusable treatment plans. Apply one to a patient from their page." />
      <Therapies />
    </div>
  );
}
